import React, { useEffect } from 'react'
import { themeChange } from 'theme-change'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { SettingsProvider } from './contexts/SettingsContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { DocumentViewerProvider } from './contexts/DocumentViewerContext'
import { AuthProvider } from './contexts/AuthContext'
import KioskUiScaleSync from './components/KioskUiScaleSync'
import KioskInactivityGuard from './components/KioskInactivityGuard'
import KioskVirtualKeyboard from './components/KioskVirtualKeyboard'
import RequireAuth from './components/RequireAuth'
import MustChangePasswordGate from './components/MustChangePasswordGate'
import LegalAcceptanceGate from './components/LegalAcceptanceGate'
import UpdatesModalGate from './components/UpdatesModalGate'
import DashboardPage from './pages/DashboardPage'
import FormsPage from './pages/FormsPage'
import ProjectsPage from './pages/ProjectsPage'
import ResourcesPage from './pages/ResourcesPage'
import AdminPage from './pages/AdminPage'
import ProfilePage from './pages/ProfilePage'
import LoginPage from './pages/LoginPage'
import AIAssistantModal from './components/AIAssistantModal'
import DocumentViewerModal from './components/DocumentViewerModal'
import TallyPage from './pages/TallyPage';
import AppTemplatePage from './pages/AppTemplatePage'
import PRAppPage from './pages/PRAppPage'
import ControlCenterPage from './pages/ControlCenterPage'
import HRPage from './pages/HRPage'
import RequirePermission from './components/RequirePermission'
import ScrollToTop from './components/ScrollToTop'
const FormManagement = React.lazy(() => import('./pages/forms/FormManagement'))
const ProjectManagement = React.lazy(() => import('./pages/projects/ProjectManagement'))

function App() {
  useEffect(() => {
    window.__ltsMarkAppReady?.()
    themeChange(false)
  }, [])

  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <SettingsProvider>
          <KioskUiScaleSync />
          <KioskInactivityGuard />
          <KioskVirtualKeyboard />
          <NotificationProvider>
            <DocumentViewerProvider>
              <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/*"
                element={
                  <RequireAuth>
                    <MustChangePasswordGate>
                    <LegalAcceptanceGate>
                      <UpdatesModalGate>
                      <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/forms" element={<FormsPage />} />
                      <Route path="/forms/manage" element={
                        <RequirePermission perm="formsManager">
                          <React.Suspense fallback={null}>
                            <FormManagement />
                          </React.Suspense>
                        </RequirePermission>
                      } />
                      <Route path="/projects" element={<ProjectsPage />} />
                      <Route path="/projects/manage" element={
                        <RequirePermission perm="projectsManager">
                          <React.Suspense fallback={null}>
                            <ProjectManagement />
                          </React.Suspense>
                        </RequirePermission>
                      } />
                      <Route path="/resources" element={<ResourcesPage />} />
                      <Route
                        path="/template"
                        element={
                          <RequirePermission perm="template">
                            <AppTemplatePage />
                          </RequirePermission>
                        }
                      />
                      <Route
                        path="/pr"
                        element={
                          <RequirePermission perm="pr">
                            <PRAppPage />
                          </RequirePermission>
                        }
                      />
                      <Route
                        path="/control-center"
                        element={
                          <RequirePermission perm="controlCenter">
                            <ControlCenterPage />
                          </RequirePermission>
                        }
                      />
                      <Route path="/admin" element={<AdminPage />} />
                      <Route
                        path="/hr"
                        element={
                          <RequirePermission perm="hrManager">
                            <HRPage />
                          </RequirePermission>
                        }
                      />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/tally" element={<TallyPage />} />
                      </Routes>
                      </UpdatesModalGate>
                    </LegalAcceptanceGate>
                    </MustChangePasswordGate>
                  </RequireAuth>
                }
              />
              </Routes>
              {/* Global Modals */}
              <AIAssistantModal />
              <DocumentViewerModal />
            </DocumentViewerProvider>
          </NotificationProvider>
        </SettingsProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
